import { DetailsSidePanelProps } from "PFApp/booking/components/details_panel/details_panel_item";
import { useBooking } from "PFCore/hooks/queries";

import BookingActivityContextProvider from "../../parts/providers/booking_activity_context_provider";
import {
  BookingFormDataCreateMode,
  BookingFormDataEditOrCloneMode,
  BookingFormMode
} from "./booking_form.types";
import { BookingFormProvider } from "./booking_form_provider";
import { OnSuccessData } from "./use_handle_submit/use_handle_submit";

export const BookingFormWrapper = ({
  show,
  zIndex,
  data: panelData,
  activeBookingIndex,
  setActiveBookingIndex,
  disableEntranceAnimation
}: DetailsSidePanelProps) => {
  const { data, props: bookingFormProps } = panelData.bookingFormDetails ?? {};
  const bookingFormMode = bookingFormProps?.mode ?? BookingFormMode.Create;

  const bookingId =
    bookingFormMode === BookingFormMode.Create
      ? undefined
      : (data as BookingFormDataEditOrCloneMode | undefined)?.bookingId;
  const { data: booking } = useBooking(bookingId, { enabled: !!bookingId });

  const activityId =
    bookingFormMode === BookingFormMode.Create
      ? (data as BookingFormDataCreateMode | undefined)?.activityId
      : booking?.activity?.id;

  const handleSuccess = async (data: OnSuccessData) => {
    bookingFormProps?.onSuccess?.(data);
  };

  if (!setActiveBookingIndex) {
    throw new Error("BookingForm requires setActiveBookingIndex!");
  }

  return (
    <BookingActivityContextProvider id={activityId}>
      <BookingFormProvider
        show={show}
        zIndex={zIndex}
        initialData={data}
        initialBooking={booking}
        onSuccess={handleSuccess}
        mode={bookingFormMode}
        source={bookingFormProps?.source}
        bookingModuleDetails={panelData.bookingModuleDetails}
        onPreSubmitAction={bookingFormProps?.customPreSubmitAction}
        activeBookingIndex={activeBookingIndex}
        setActiveBookingIndex={setActiveBookingIndex}
        disableEntranceAnimation={disableEntranceAnimation}
      />
    </BookingActivityContextProvider>
  );
};
